import PropTypes from 'prop-types';
import {t} from 'shared/core';
import Checkbox from 'shared/components/Checkbox';

const PanelCheckbox = ({checked, onChange, label, description, className = '', children, disabled, translateLabel = true, translateDescription = true}) => {
  const toggle = () => !disabled && onChange({checked: !checked});

  return (
    <div className={`border rounded p2 ${disabled ? 'nonclickable' : ''} ${className}`}>
      <div className='flex align-items-start'>
        <Checkbox disabled={disabled} checked={checked} onChange={onChange}/>
        <div className='pl1 flex-1'>
          <div className={disabled ? 'waterloo' : 'clickable'} onClick={toggle}>
            <div className='medium'>{translateLabel ? t(label) : label}</div>
            {description && (
              <div className='jumbo'>{translateDescription ? t(description) : description}</div>
            )}
          </div>
          {checked && !disabled && !!children && <div className='mt2'>{children}</div>}
        </div>
      </div>
    </div>
  );
};

PanelCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
  description: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  translateLabel: PropTypes.bool,
  translateDescription: PropTypes.bool
};

export default PanelCheckbox;
